// frontend/src/pages/NotFound.tsx
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function NotFound() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "404 – Page Not Found";
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 text-slate-900 dark:text-slate-100">
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/20 text-red-600 dark:text-red-400 mb-4 text-3xl font-bold">
          404
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold mb-2">
          Page not found
        </h1>

        <p className="text-gray-600 dark:text-gray-300 mb-6">
          We couldn't find{" "}
          <span className="font-mono break-all text-sm bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded">
            {pathname}
          </span>
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2 rounded border border-black/10 dark:border-white/10 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            aria-label="Go back to previous page"
          >
            ← Go Back
          </button>
          <Link
            to="/"
            className="px-6 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            aria-label="Go to Home"
          >
            Go Home
          </Link>
        </div>

        <div className="text-sm text-gray-500 dark:text-gray-400">
          Quick links:{" "}
          <Link
            to="/video"
            className="underline hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            Video
          </Link>
          {" · "}
          <Link
            to="/history"
            className="underline hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            History
          </Link>
          {" · "}
          <Link
            to="/backgrounds"
            className="underline hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            Backgrounds
          </Link>
        </div>
      </div>
    </div>
  );
}